var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 7.33334V11.3333C14.6663 14 13.9997 14.6667 11.333 14.6667H4.66634C1.99967 14.6667 1.33301 14 1.33301 11.3333V4.66668C1.33301 2.00001 1.99967 1.33334 4.66634 1.33334H5.66634C6.66634 1.33334 6.88634 1.62668 7.26634 2.13334L8.26634 3.46668C8.51967 3.80001 8.66634 4.00001 9.33301 4.00001H11.333C13.9997 4.00001 14.6663 4.66668 14.6663 7.33334Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 1.33334H11.333C12.6663 1.33334 13.333 2.00001 13.333 3.33334V4.25334",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.173710fd46373ad7fa948ef493495edd.svg";
export { ForwardRef as ReactComponent };